import { httpUrl } from './httpUrl'
import { getData, ifOkToJson, post } from './index'

let baseUrl = `${httpUrl.host}/gy-gas`
// let baseUrl3 = `${httpUrl.host}/gy-apartment`
let baseUrl85 = `${httpUrl.host}/gy-apartment`
let baseUrl86 = `${httpUrl.host}/gy-log`

let api = {
  // <!--概览-->
  // 概览 ———— 燃气表
  getGasMeterDeviceOverview: `${baseUrl}/gasOverview/getGasMeterDeviceOverview`,

  // 概览 ———— 集中器
  getGasControlDeviceOverview: `${baseUrl}/gasOverview/getGasControlDeviceOverview`,

  // 概览 ———— 当月燃气量/燃气费
  getCurrentMonthGasity: `${baseUrl}/gasOverview/getCurrentMonthGasity`,

  // 概览 ———— 燃气量统计
  getGasityStatistics: `${baseUrl}/gasOverview/getGasityStatistics`,

  // 概览 ———— 充值统计
  getGasRechargeStatistics: `${baseUrl}/gasOverview/getStatistics`,
  // <!--概览-->

  // <!--设备管理-->
  // 设备管理 ———— 查询是否可配置欠费是否关闸
  autoOffSupport: `${baseUrl}/gasMeterDevice/autoOffSupport`,

  // 设备管理 ———— 集中器分页
  getGasControlDevicePage: `${baseUrl}/gasControlDevice/getPage`,

  // 设备管理 ———— 集中器列表
  getGasControlDeviceList: `${baseUrl}/gasControlDevice/getList`,

  // 设备管理 ———— 集中器详情
  getGasControlDeviceByCode: `${baseUrl}/gasControlDevice/getByCode`,

  // 设备管理 ———— 集中器添加
  addGasControlDevice: `${baseUrl}/gasControlDevice/add`,

  // 设备管理 ———— 集中器删除
  deleteGasControlDeviceByCodes: `${baseUrl}/gasControlDevice/deleteByCodes`,

  // 设备管理 ———— 集中器修改
  updateGasControlDevice: `${baseUrl}/gasControlDevice/update`,

  // 设备管理 ———— 燃气表分页
  getGasMeterDevicePage: `${baseUrl}/gasMeterDevice/getPage`,

  // 设备管理 ———— 燃气表列表
  getGasMeterDeviceList: `${baseUrl}/gasMeterDevice/getList`,

  // 设备管理 ———— 燃气表详情
  getGasMeterDeviceByCode: `${baseUrl}/gasMeterDevice/getByCode`,

  // 设备管理 ———— 燃气表添加
  addGasMeterDevice: `${baseUrl}/gasMeterDevice/add`,

  // 设备管理 ———— 燃气表删除
  deleteGasMeterDeviceByCodes: `${baseUrl}/gasMeterDevice/deleteByCodes`,

  // 设备管理 ———— 燃气表修改
  updateGasMeterDevice: `${baseUrl}/gasMeterDevice/update`,

  // 设备管理 ———— 手动开关
  updatePowerOnOrOff: `${baseUrl}/gasMeterDevice/updatePowerOnOrOff`,

  // 设备管理 ———— 导出燃气表
  exportGasMeterDevice: `${baseUrl}/gasMeterDevice/export`,

  // 设备管理 ———— 历史燃气量
  gasSupply: `${baseUrl}/gasSupply/getPage`,
  // <!--设备管理-->

  // <!--燃气配置-->
  // 燃气配置 ———— 收费配置
  getGasPayConfig: `${baseUrl}/gasPayConfig/get`,

  // 燃气配置 ———— 修改收费配置
  updateGasPayConfig: `${baseUrl}/gasPayConfig/update`,

  // 燃气配置 ———— 场景分页
  getGasScenePage: `${baseUrl}/gasScene/getPage`,

  // 燃气配置 ———— 场景列表
  getGasSceneList: `${baseUrl}/gasScene/getList`,

  // 燃气配置 ———— 场景添加
  addGasScene: `${baseUrl}/gasScene/add`,

  // 燃气配置 ———— 场景详情
  getGasSceneByCode: `${baseUrl}/gasScene/getByCode`,

  // 燃气配置 ———— 场景修改
  updateGasScene: `${baseUrl}/gasScene/update`,

  // 燃气配置 ———— 场景删除
  deleteGasSceneByCodes: `${baseUrl}/gasScene/deleteByCodes`,
  // <!--燃气配置-->

  // <!--燃气统计-->
  // 燃气统计 ———— 按燃气表统计查询
  getGasBillMeterPage: `${baseUrl}/gasBillMeter/getPage`,

  // 燃气统计 ———— 按燃气表统计导出
  exportGasBillMeter: `${baseUrl}/gasBillMeter/export`,

  // 燃气统计 ———— 按住户统计查询
  getGasBillEnterprisePage: `${baseUrl}/gasBillEnterprise/getPage`,

  // 燃气统计 ———— 按住户统计导出
  exportGasBillEnterprise: `${baseUrl}/gasBillEnterprise/export`,
  // <!--燃气统计-->

  // <!--余额管理-->
  // 余额管理 ———— 分页
  getGasRentMoneyPage: `${baseUrl}/gasRentMoney/getPage`,
  // <!--余额管理-->

  // <!--充值记录-->
  // 充值记录 ———— 分页
  getGasConsumptionRecordPage: `${baseUrl}/gasConsumptionRecord/getPage`,
  // <!--充值记录-->

  // <!--结算记录-->
  // 结算记录 ———— 分页
  getGasSettlementPage: `${baseUrl}/gasSettlement/getPage`,
  // <!--结算记录-->

  // <!--设备状态日志-->
  // 设备状态日志 ———— 分页
  getGasDeviceStatusPage: `${baseUrl}/gasDeviceStatus/getPage`,

  // 设备状态日志 ———— 导出
  exportGasDeviceStatus: `${baseUrl}/gasDeviceStatus/export`,
  // <!--设备状态日志-->

  // 获取园区责任人
  getResponsiblePersonList: `${baseUrl85}/person/getResponsiblePersonList`,

  // 获取楼栋列表
  getBuildingList: `${baseUrl85}/building/getBuildingList`,

  //获取燃气费结算配置
  getGasSettlementConfig: `${baseUrl}/gasSettlementConfig/get`,

  //燃气费结算配置保存
  saveGasSettlementConfig: `${baseUrl}/gasSettlementConfig/save`,

  //级别燃气量统计
  getGasLevelStatistics: `${baseUrl}/gasOverview/getStatistics`,

  //场景燃气量统计
  getGasStatistics: `${baseUrl}/gasOverview/getSceneStatistics`,

  // 燃气表最新读数—分页
  getGasRealRecordPage: `${baseUrl}/gasRealRecord/getPge`,

  // 燃气表最新读数—导出
  exportGasRealRecord: `${baseUrl}/gasRealRecord/export`,

  // 生成燃气表标签
  generateCipherText: `${baseUrl}/codeScanning/generateCipherText`,

  // 导出燃气表标签
  exportCodeScanning: `${baseUrl}/codeScanning/export`,

  // 读表器管理—分页
  getGasReaderDevicePage: `${baseUrl}/gasReaderDevice/getPage`,

  // 操作日志
  getgasLogPage: `${baseUrl86}/log/getPage`
}

export { api }



// WEBPACK FOOTER //
// ./src/view/api/GasManagement.js